/* IFA 2026 产品页 —— Hero 轮播 / More Products 横滑 / 折叠
 *
 * 纪律（都是踩出来的）：
 *  · 不做「加载时宽度不符就 return」—— 监听照挂、判定放函数内部，
 *    否则「桌面加载 → 缩窄」这条路径永远是坏的（只测直接以手机宽度加载发现不了）。
 *  · 用事件委托 + 逐 section 初始化，主题编辑器里增删 block 也能重新绑定。
 *  · 所有 DOM 查询都限定在 section 容器内，避免多个实例互相干扰。
 */
(function () {
  'use strict';

  /* --- Hero 轮播 ------------------------------------------------------- */
  function initHero(root) {
    var media = root.querySelector('[data-ifa-hero-media]');
    if (!media) return;

    var slides = Array.prototype.slice.call(media.querySelectorAll('.ifa-hero__slide'));
    var dots = Array.prototype.slice.call(media.querySelectorAll('[data-ifa-hero-dot]'));
    if (slides.length < 2) return;

    media.setAttribute('data-multi', '');
    var index = 0;
    var timer = null;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === index); });
      dots.forEach(function (d, n) { d.setAttribute('aria-current', n === index ? 'true' : 'false'); });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        show(parseInt(dot.getAttribute('data-ifa-hero-dot'), 10) || 0);
        restart();
      });
    });

    function restart() {
      if (timer) clearInterval(timer);
      // 尊重「减少动态效果」的系统设置，不自动播放
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { show(index + 1); }, 5000);
    }

    show(0);
    restart();
  }

  /* --- More Products 横滑 ---------------------------------------------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-ifa-track]');
    if (!track) return;

    var prev = root.querySelector('[data-ifa-prev]');
    var next = root.querySelector('[data-ifa-next]');
    var progress = root.querySelector('[data-ifa-progress]');

    function step() {
      var card = track.querySelector('.ifa-carousel__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      // 容差 1px：不同缩放/像素比下 scrollLeft 会差零点几，严格比较会让按钮在到底时不置灰
      if (prev) prev.disabled = track.scrollLeft <= 1;
      if (next) next.disabled = track.scrollLeft >= max - 1;

      if (progress) {
        var visible = track.clientWidth / track.scrollWidth;
        var ratio = max > 0 ? track.scrollLeft / max : 0;
        progress.style.width = Math.max(visible * 100, 12) + '%';
        progress.style.transform = 'translateX(' + (ratio * (100 / Math.max(visible, 0.12) - 100)) + '%)';
      }
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    track.addEventListener('scroll', sync, { passive: true });
    // 断点切换会改变卡宽和可滚动量，必须重算 —— 只在初始化时算一次，缩放后进度条就错了
    if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
    sync();
  }

  /* --- 折叠 ------------------------------------------------------------ */
  function initAccordion(root) {
    root.querySelectorAll('[data-ifa-acc-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        // 用 hidden 属性而非 class：语义正确，且 CSS 里已补 [hidden]{display:none!important}
        // （UA 样式表的 [hidden] 优先级低于自己写的 display，不补会「默认就是展开的」）
        panel.hidden = open;
      });
    });
  }

  /* --- Header 菜单抽屉 ------------------------------------------------ */
  function initHeaderMenu(root) {
    var toggle = root.querySelector('[data-ifa-menu-toggle]');
    var dialogId = toggle ? toggle.getAttribute('aria-controls') : '';
    var dialog = dialogId ? document.getElementById(dialogId) : null;
    if (!toggle || !dialog) return;

    function normalizeTitle(text) {
      return (text || '').replace(/\s+/g, ' ').trim().toLowerCase();
    }

    function canonicalTitle(text) {
      return normalizeTitle(text)
        .replace(/[^a-z0-9\u4e00-\u9fa5]+/g, ' ')
        .replace(/\b([a-z]{4,})s\b/g, '$1')
        .trim();
    }

    function setCat(btn, open) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (panel) panel.hidden = !open;
    }

    function expandMatchedCat(title) {
      var target = canonicalTitle(title);
      if (!target) return;
      dialog.querySelectorAll('[data-ifa-cat-btn]').forEach(function (btn) {
        var label = canonicalTitle(btn.textContent);
        setCat(btn, label === target || label.indexOf(target) === 0 || target.indexOf(label) === 0);
      });
    }

    function setOpen(open) {
      dialog.hidden = !open;
      dialog.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('ifa-dialog-open', open);
    }

    toggle.addEventListener('click', function () {
      setOpen(dialog.hidden);
    });

    dialog.querySelectorAll('[data-ifa-dialog-close], [data-ifa-dialog-backdrop]').forEach(function (el) {
      el.addEventListener('click', function () { setOpen(false); });
    });

    dialog.querySelectorAll('[data-ifa-cat-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        setCat(btn, !open);
      });
    });

    document.addEventListener('ifa:open-header-menu', function (e) {
      setOpen(true);
      expandMatchedCat(e.detail && e.detail.title);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !dialog.hidden) setOpen(false);
    });
  }

  function initAll(scope) {
    var el = scope || document;
    el.querySelectorAll('[data-ifa-hero]').forEach(initHero);
    el.querySelectorAll('[data-ifa-carousel]').forEach(initCarousel);
    el.querySelectorAll('.ifa-accordion').forEach(initAccordion);
    el.querySelectorAll('[data-ifa-header]').forEach(initHeaderMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // 主题编辑器里增删/重载 section 后重新初始化，否则编辑器里预览是死的
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
